/**
 * Class 1 is the TDG explosives class; its classifications start with "1"
 * (e.g. "1.1D"). Net explosive quantity only applies to Class 1.
 */
export function dangerousGoodsIsClass1Explosive(
  dangerousClassification: string | undefined,
): boolean {
  return dangerousClassification?.startsWith("1") ?? false;
}
